import {
  readBooleanPreference,
  writeBooleanPreference
} from '@/utils/readBooleanPreference';

const PREF_COLLAPSED = 'hr-sidebar-collapsed';
const PREF_HOVER_EXPAND = 'hr-sidebar-hover-expand';

export default {
  namespaced: true,
  state: {
    sidebar: {
      isCollapsed: readBooleanPreference(PREF_COLLAPSED, false),
      hoverExpandEnabled: readBooleanPreference(PREF_HOVER_EXPAND, false),
      isReady: true
    }
  },
  mutations: {
    setSidebarReady(state, isReady) {
      state.sidebar.isReady = !!isReady;
    },
    setSidebarCollapsed(state, isCollapsed) {
      state.sidebar.isCollapsed = !!isCollapsed;
      writeBooleanPreference(PREF_COLLAPSED, state.sidebar.isCollapsed);
    },
    toggleSidebarCollapsed(state) {
      state.sidebar.isCollapsed = !state.sidebar.isCollapsed;
      writeBooleanPreference(PREF_COLLAPSED, state.sidebar.isCollapsed);
    },
    setHoverExpandEnabled(state, enabled) {
      state.sidebar.hoverExpandEnabled = !!enabled;
      writeBooleanPreference(PREF_HOVER_EXPAND, state.sidebar.hoverExpandEnabled);
    },
    toggleHoverExpandEnabled(state) {
      state.sidebar.hoverExpandEnabled = !state.sidebar.hoverExpandEnabled;
      writeBooleanPreference(PREF_HOVER_EXPAND, state.sidebar.hoverExpandEnabled);
    }
  }
};
